import { Contact } from "../../screens/Dashboard/ContactPhone/ContactPhoneModal";
import { IpPhoneActions, IpPhoneActionTypes } from "./actions";

export const ipPhoneInitialState = {
  isPhoneCall: false,
  callSid: undefined as string | undefined,
  incomingCallStatus: undefined as IncomingCallStatus | undefined,
  deviceStatus: null as DeviceStatus | null,
  ipPhoneToken: undefined as string | undefined,
  callRoom: undefined as CallRoom | undefined,
  settings: undefined as IpPhoneSettings | undefined,
  isUpdatingSettings: false,
  makeCallNumber: undefined as string | undefined,
};

export type ipPhoneState = typeof ipPhoneInitialState;

export type CallAction = "accept" | "reject";

export type CallRoom = {
  identity: string;
  roomName: string;
};

export type IncomingCallStatus = {
  callSid: string | undefined;
  callAction: CallAction;
};

export type DeviceStatus = "connected" | "disconnected" | "reconnecting";

export type IpPhoneSettings = {
  phoneNumbers?: string[];
  routingMode?: string;
  contacts?: Contact[];
  micVolume?: number;
};

export function ipPhoneReducer(state: ipPhoneState = ipPhoneInitialState, action: IpPhoneActionTypes): ipPhoneState {
  switch (action.type) {
    case IpPhoneActions.SET_IS_PHONE_CALL:
      return { ...state, isPhoneCall: action.payload.isPhoneCall };
    case IpPhoneActions.SET_CALL_SID:
      return { ...state, callSid: action.payload.callSid };
    case IpPhoneActions.UPDATE_INCOMING_CALL_STATUS:
      return { ...state, incomingCallStatus: action.payload.incomingCallStatus };
    case IpPhoneActions.UPDATE_DEVICE_STATUS:
      return { ...state, deviceStatus: action.payload.deviceStatus };
    case IpPhoneActions.SET_IP_PHONE_TOKEN:
      return { ...state, ipPhoneToken: action.payload.ipPhoneToken };
    case IpPhoneActions.SET_CALL_ROOM:
      return { ...state, callRoom: action.payload.callRoom };
    case IpPhoneActions.SET_IP_PHONE_SETTINGS:
      return { ...state, settings: action.payload.settings };
    case IpPhoneActions.SET_IS_UPDATING_SETTINGS:
      return { ...state, isUpdatingSettings: action.payload.isUpdatingSettings };
    case IpPhoneActions.SET_MAKE_CALL_NUMBER:
      return { ...state, makeCallNumber: action.payload.makeCallNumber };
    default:
      return state;
  }
}
